import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Table } from 'react-bootstrap'

import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import { SocketContext } from '../context/SocketContext'
import { useHideMenu } from '../hooks/useHideMenu'
import { useGetPantallas } from '../hooks/useGetPantallas'
import { getUsuarioStorage } from '../helpers/getUsuarioStorage'

import { SelectElement } from '../components/selectElement'
import LoadingOverlay from '../components/LoadingOverlay'
import { NoAcceso } from '../components/NoAcceso'



const pasarMayusculas= (ev) =>{
    ev.preventDefault();
    ev.target.defaultValue= ev.target.defaultValue.toUpperCase();
    ev.target.value= ev.target.value.toUpperCase();
}


const MySwal = withReactContent(Swal);

const sweet = ( title, html, icon ) =>{ MySwal.fire({ title, html, icon, confirmButtonColor: 'LightSeaGreen', timer: 15000  }) }
    
const sweetConfirm = ( title, html, icon ) =>{  
    return MySwal.fire({ 
  
        title, 
        html, 
        icon, 
        confirmButtonText: 'Ok',
        confirmButtonColor: 'LightSeaGreen',  
        showCancelButton: true, 
        cancelButtonColor: '#d33',  
        cancelButtonText: 'Cancelar' 
    }) 
}



export const ModulosCreacion = () => {

    let [usuario] = useState( getUsuarioStorage() );
    const entidad = usuario.entidad;
    const pantallas = useGetPantallas();
    
    const navigate = useNavigate();
    useEffect(() => {
        if(usuario.uidUsuario === null){
            // return <Navigate to="/ingreso" />
            navigate("/Ingreso")
        }
    }, [usuario.uidUsuario, navigate ])

    useHideMenu(false);
    
    const { socket } = useContext( SocketContext );

    const [ moduloClaseRegistro, setModuloClaseRegistro ] = useState();
    const [ moduloClases, setModuloClases ] = useState('');
    const [ isLoading, setIsLoading ] = useState(false);
    

    
    // tabla
    const [data, setData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    let   [sortedBy, setSortedBy] = useState('modulo');
    let   [sortDirection, setSortDirection] = useState('asc');

    const datos={
        entidad,
        search : searchTerm || '',
        page: currentPage || '',
        itemsPerPage: itemsPerPage || '',
        sortedBy: sortedBy,
        sortDirection: sortDirection,
       
    }
  
  
    useEffect(() => {
        async function fetchModuloClases() {
            await socket.emit('select-moduloClases', datos, ( lista ) => {
                const opciones = lista.map( (item) => ( { value: item.uidModuloClase, label: item.moduloClase.toUpperCase() } ) )
                setModuloClases( opciones )
            })
        }

        fetchModuloClases();
               
        return () => {
            socket.off('select-moduloClases')
        }
    }, [ socket ])

    useEffect(() => {
      
        async function fetchData() {
            await socket.on('lista-Modulos', ( lista ) => {
                console.log(lista);
                setData( lista )
            })
        }

        fetchData();

        return () => {
            socket.off('lista-Modulos')
        }
    }, [socket])
   
    const handleSort = async (header) => {
        console.log(header)    
        
        setSortedBy(header);
        const direction= sortDirection === 'asc' ? 'desc' : 'asc'
        setSortDirection( direction );
        datos.sortedBy= header;
        datos.sortDirection= direction;
        
        setIsLoading(true)
        socket.emit( 'lista-Modulos', datos, async ( lista ) => {
            console.log(lista)
            setData(lista);
            setIsLoading(false)
        })
           
        
    }
    
   
    

    const inactivaModulo = async (uidModulo, accion) => {
        
        const entidad = usuario.entidad;
        if( !entidad ) return sweet('Atención!', 'Revise la infromación', 'error');
        if( entidad=== null ) return sweet('Atención!', 'Revise la infromación', 'error');

        const act = accion === 1 ? "Activar" : "Inactivar";

        const confirmacion = await sweetConfirm( "Atención", `Esta seguro de ${act} el registro?`, "warning" ).then( (result) => {
            return (result);
        })

        if (!confirmacion.value) return false;
        
        datos.uidModulo= uidModulo;
        datos.accion= accion;
        
        setIsLoading(true)
        socket.emit( 'inactiva-Modulo', datos, ( res ) => {
            console.log( res )
            setIsLoading(false)
        })

    }

    const handleModuloClasesRegistro = (ev) =>{
        setModuloClaseRegistro( ev.value );
    }

    const registraModulo = async ( uidModulo ) => {

        const entidad = usuario.entidad;
        if( !entidad ) return sweet('Atención!', 'Revise la información', 'error');
        if( entidad=== null ) return sweet('Atención!', 'Revise la información', 'error');

        
        const clase    = moduloClaseRegistro;
        if( clase === "" ) return sweet('Atención!', 'Revise la información', 'error');

        datos.modulo    = document.getElementById(`modulo_${uidModulo}`).value.toUpperCase();
        datos.clase = clase;

        const registros = document.querySelectorAll('.registro');
        
        registros.forEach((elemento, index) => {
            if( elemento.value === "" ) return sweet('Atención!', 'Revise la información', 'error');
            if( elemento.value < 0    ) return sweet('Atención!', 'Revise la información', 'error');
        });

        
        setIsLoading(true)
        socket.emit( 'registra-Modulo', datos, async ( res ) => {
            setIsLoading(false)
            if( res[0] === ""){
                sweet('Atención!', res[1], 'error');
            }else if( res[0] === 1){
                sweet('', res[1], 'success');
                
                registros.forEach((elemento, index) => {
                    if( elemento.type !== "checkbox" ) elemento.value = ""
                    else elemento.checked= false;
                    delete datos[elemento.id.split("_")[0]];
                })   
            }else{
                console.log(res);
            }

          

        })

        

    }

    const editaModulo = async ( ev, uidModulo) =>{

        const campo= ev.target.id.split("_")[0];
        const valor= ( ev.target.type === 'checkbox' ) ? ev.target.checked : ev.target.value;
        const valorAnterior= ( ev.target.type === 'checkbox' ) ? ev.target.checked : ev.target.defaultValue;
        

        if ( valor !== valorAnterior || ev.target.type === 'checkbox' ){

            const confirmacion = await sweetConfirm( "Atención", "Esta seguro de Modificar el registro?", "warning" );
            if (!confirmacion.value){
                ev.target.value = valorAnterior;
                return false;
            }
            
            

            datos.campo = campo;
            datos.valor = valor;
            datos.uidModulo = uidModulo;

            setIsLoading(true)
            socket.emit( 'edita-Modulo', datos, async ( res ) => {
                setIsLoading(false)
                if( res === null){
                    
                    sweet('Atención!', 'Contacte al Administrador', 'error');
                    ev.target.value = valorAnterior;
                    console.log(res)

                }else if( res[0] === ""){
                    
                    sweet('Atención!', res[1], 'error');
                    ev.target.value = valorAnterior;

                }else if( res[0] === 1){
                    
                    delete datos[campo];
                    delete datos[valor];
                    delete datos[uidModulo];
                                           
                }else{
                    sweet('Atención!', 'Contacte al Administrador', 'error');
                    console.log(res);
                }
    
            })

        }

        
    }

    
    const handleModuloClases = (ev, uidModulo) => {

        datos.campo = "uidModuloClase";
        datos.valor = ev.value;
        datos.uidModulo = uidModulo;

        setIsLoading(true)
        socket.emit( 'edita-Modulo', datos, async ( res ) => {
            setIsLoading(false)
            console.log(res)
            if( res === null){
                
                sweet('Atención!', 'Contacte al Administrador', 'error');
               

            }else if( res[0] === ""){
                
                sweet('Atención!', res[1], 'error');
              
            }else if( res[0] === 1){
                
                // delete datos[campo];
                // delete datos[valor];
                // delete datos[uidModulo];
                                       
            }else{
                sweet('Atención!', 'Contacte al Administrador', 'error');
                console.log(res);
            }

        })
       
    };

   
    
    // **************************table
   
   
    useEffect(() => {

        
        setIsLoading(true)
        socket.emit( 'lista-Modulos', datos, async ( lista ) => {
            setIsLoading(false)
            setData(lista);
        })
        


    }, [searchTerm, currentPage, itemsPerPage]);
   


    
    const handleSearch = (ev) => {
        setSearchTerm(ev.target.value);
        setCurrentPage(1); // Reset to the first page when searching
    };

    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    // const indexOfLastItem = currentPage * itemsPerPage;
    // const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = data.slice(0, itemsPerPage);

   
   
    if( usuario.uidUsuario === null ) {
        return(
            <>
            </>
        )
    }
    else if( !pantallas.includes("creacionescritorios") ) {
        return( <NoAcceso /> )
    } 
    else{

        return (
            <>
                {isLoading && <LoadingOverlay />}
                <div className={`content ${isLoading ? 'opacity' : ''} m-5`} style={{minHeight:'100vh'}}>
                  
                    <div>

                        <div className='row'>
                            

                            <div className='col-lg-2 col-12 '>
                                <button
                                    className='btn btn-success m-3'
                                    data-bs-toggle="collapse" 
                                    data-bs-target="#divAgregaModulo"
                                >
                                Agregar Módulo
                                </button> 
                                
                            </div>
                        </div>

                        <div id='divAgregaModulo'  className='row border border-info rounded shadow p-3 collapse hide'>
                            <Table responsive="md" striped hover style={{minWidth: 300}} className='max400' >
                                <thead>
                                    <tr >
                                        <th width={'5%'}></th>
                                        <th width={'40%'}>Clase</th>
                                        <th width={'55%'}>Módulo</th>
                                        
                                    </tr>
                                </thead>
                                <tbody   >
            
                                    <tr style={{minHeight: 150}}>
                                        <td width={'5%'}>
                                            <button
                                                className='btn btn-sm btn-primary me-1'
                                                onClick={ ()=> registraModulo('') }
                                            > 
                                            <i className='fas fa-save'></i>
                                            </button> 

                                        </td>

                                        <td width={'40%'}> 
                                            {/* <div className='form-group col-12' > */}
                                                {/* <div className='label'>Tipos Atención</div> */}
                                                <SelectElement
                                                    options= { moduloClases }
                                                    name={ `uidModuloClase_`}
                                                    isMulti= {false}
                                                    closeOnMenuSelect= {true}
                                                    onChange= {(ev) => handleModuloClasesRegistro(ev)}
                                                    classname= "form-control form-control-lg" 
                                                    isClearable = {false}
                                                />

                                            {/* </div> */}

                                        </td>


                                        <td width={'55%'}> 
                                            <input
                                                type='text'
                                                className='form-control registro'
                                                id='modulo_'
                                            />
                                        </td>
                                        
                                        
                                    </tr>
                                
                                </tbody>
                            </Table>

                        </div>

                        <hr />

                        

                        <div className='row rounded shadow p-3'>

                            <div className='col-12'>
                                <div className='float-start col-lg-4 col-12 pagination'>
                                    <button
                                        className='btn btn-sm btn-secondary m-1'
                                        onClick={() => paginate(currentPage - 1)}
                                        disabled={currentPage === 1}
                                    >
                                    {"<"}
                                    </button> 
                                    <button
                                        className='btn btn-sm btn-secondary m-1'
                                        onClick={() => paginate(currentPage + 1)}
                                        disabled={currentItems.length < itemsPerPage}
                                    >
                                    {">"}
                                    </button>
                                </div>
                        
                                <div className=' float-end col-lg-4 col-12'>

                                    <input
                                        type='text'
                                        placeholder='Buscar...'
                                        className='form-control'
                                        maxLength={20}
                                        defaultValue={searchTerm}
                                        onChange={ (ev) => handleSearch(ev)}
                                    />

                                </div>
                            
                            </div>

                            <div className='col-12'>
                                <Table responsive="md" striped hover style={{minWidth: 600}} className='max400'>
                                    <thead>
                                    <tr>
                                        <th width={'5%'}></th>
                                        <th width={'20%'} onClick={ () => handleSort('moduloClase') } >
                                            Clase
                                            {sortedBy === 'moduloClase' && sortDirection === 'asc' && '▲'}
                                            {sortedBy === 'moduloClase' && sortDirection === 'desc' && '▼'}
                                        </th>
                                        <th width={'75%'} onClick={ () => handleSort('modulo') } >
                                            Módulo
                                            {sortedBy === 'modulo' && sortDirection === 'asc' && '▲'}
                                            {sortedBy === 'modulo' && sortDirection === 'desc' && '▼'}
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody width={'100%'}  >
                
                                    {
                                        
                                        currentItems.length === 0 
                                        ?   (   <tr>
                                                    <td width={'100%'} style= {{textAlign:'center'}}> No Hay Registros </td>
                                                </tr>
                                            )
                                        : 
                                        currentItems.map((item) => (

                                            <tr key={item.uidModulo}>
                                                <td width={'5%'}>
                                                
                                                    {   (item.indActivo=== 1) 
                                                        ?(
                                                            <button
                                                                className='btn btn-sm btn-danger'
                                                                onClick={() => inactivaModulo( item.uidModulo, 0 ) }
                                                            > 
                                                            <i className='fa-solid fa-minus'></i>
                                                            </button>
                                                        )
                                                        :(
                                                            <button
                                                                className='btn btn-sm btn-success'
                                                                onClick={() => inactivaModulo( item.uidModulo, 1 ) }
                                                            > 
                                                            <i className='fa-solid fa-plus'></i>
                                                            </button>
                                                        )
                                                    
                                                    }
                                                    


                                                </td>

                                                <td width={'20%'}> 
                                                    {item.moduloClase.toUpperCase()}
                                                    
                                                </td>
                                                <td width={'75%'}> 
                                                    { (item.indActivo=== 1) 
                                                        ? (
                                                            <input
                                                                type='text'
                                                                className='form-control'
                                                                id={`modulo_${item.uidModulo}`}
                                                                defaultValue={item.modulo.toUpperCase()}
                                                                maxLength={20}
                                                                onBlur={ (ev) => editaModulo( ev, item.uidModulo)}
                                                                onChange={ (ev) => pasarMayusculas( ev )}
                                                            />
                                                        )
                                                        :(
                                                            item.modulo.toUpperCase()

                                                        )
                                                    
                                                    }
                                               </td>
                                                
                                            </tr>
                                        ))
                                    }
                                    </tbody>
                                </Table>
                            </div>

                            <div className='pagination'>
                                <button
                                    className='btn btn-sm btn-secondary m-1'
                                    onClick={() => paginate(currentPage - 1)}
                                    disabled={currentPage === 1}
                                >
                                {'<'}
                                </button> 
                                <button
                                    className='btn btn-sm btn-secondary m-1'
                                    onClick={() => paginate(currentPage + 1)}
                                    disabled={currentItems.length < itemsPerPage}
                                >
                                {'>'}
                                </button>
                            </div>
                            
                        </div>
                        
                                    
                    </div>
        
                    

                </div>    
            </>
        )
    }
}
